<template>
    <div>
        <div class="content-page" style="background-color: #f7f7f7; ">
            <div class="content">
                <!-- Start Content-->
                <div class="container-fluid">
                    <div class="row" style="font-size:13px;">

                        <div class="cols-xl-2 cols-sm-12 col-md-6">
                            <div class="card widget-box-two bg-purple">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body wigdet-two-content">
                                            <p class="m-0 text-uppercase text-white" title="Interest for this Month">WHT - INTEREST - MTD </p>
                                            <h5 class="text-white num"><span data-plugin="counterup">{{Interest.amount | toCurrency}}</span> </h5>
                                            <p class="text-white m-0"> COUNT - <b>{{Interest.count}}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- end col -->

                        <div class="cols-xl-2 cols-sm-12 col-md-6">
                            <div class="card widget-box-two bg-info">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body wigdet-two-content">
                                            <p class="m-0 text-white text-uppercase" title="Dividened for this Month">WHT - DIVIDENDS - MTD</p>
                                            <h5 class="text-white num"><span data-plugin="counterup">{{Dividend.amount | toCurrency}}</span> </h5>
                                            <p class="text-white m-0"> COUNT - <b>{{Dividend.count}}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- end col -->

                        <div class="cols-xl-2 cols-sm-12 col-md-6">
                            <div class="card widget-box-two bg-pink">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body wigdet-two-content">
                                            <p class="m-0 text-uppercase text-white" title="Rent for this Month">WHT - RENT - MTD</p>
                                            <h5 class="text-white num"><span data-plugin="counterup">{{Rent.amount | toCurrency}}</span> </h5>
                                            <p class="text-white m-0"> COUNT - <b>{{Rent.count}}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- end col -->

                        <div class="cols-xl-2 cols-sm-12 col-md-6">
                            <div class="card widget-box-two bg-success">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body wigdet-two-content">
                                            <p class="m-0 text-white text-uppercase" title="Contract for this Month">WHT - CONTRACT - MTD</p>
                                            <h5 class="text-white num"><span data-plugin="counterup">{{Contract.amount | toCurrency}}</span> </h5>
                                            <p class="text-white m-0"> COUNT - <b>{{Contract.count}}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- end col -->

                        <div class="cols-xl-2 cols-sm-12 col-md-6">
                            <div class="card widget-box-two bg-dark">
                                <div class="card-body">
                                    <div class="media">
                                        <div class="media-body wigdet-two-content">
                                            <p class="m-0 text-white text-uppercase" title="Royalties for this Month">WHT - ROYALTIES - MTD</p>
                                            <h5 class="text-white num"><span data-plugin="counterup">{{Royalty.amount | toCurrency}}</span> </h5>
                                            <p class="text-white m-0"> COUNT - <b>{{Royalty.count}}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- end col -->

                    </div>
                    <!-- end row -->

                    <div class="row" >
                        <div class="col-xl-6 pt-100" style="padding-top: 20px;">
                            <div class="card" style="height:386px">
                                <div class="card-body" style="height:300px;margin-left:25px">
                                    <span class="header-title mb-3">Pie Chart - Pecentage of collections by categories MTD</span>
                                    <!--========= CONTENT HERE ========== -->
                                    <div style="text-align:center">
                                        <apexchart width="450" type="donut" :options="options1" :series="series1" v-if="plotnow"></apexchart>
                                        <div style="color:#ccc; margin-top:20%; font-size:20px; margin-left:-50px" v-if="!plotnow">
                                            <v-icon name="pie-chart" style="width:50px"></v-icon><br>No Record
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 pt-10" style="padding-top: 20px;">
                            <div class="card" style="height:386px">
                                <div class="card-body" >
                                    <span class="header-title mb-20 font-22">Bar Chart - Total Collections YTD</span>
                                    <!--========= CONTENT HERE ========== -->
                                    <div style="text-align:center">
                                        <apexchart width="500" type="bar" :options="options" :series="series" v-if="plotYear"></apexchart>
                                        <div style="color:#ccc; margin-top:20%; font-size:20px; margin-left:-50px" v-if="!plotYear">
                                            <v-icon name="bar-chart" style="width:50px"></v-icon><br>No Record
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- end row -->

                    <div class="row" >
                        <div class="col-xl-6" style="padding-top: 30px;" >
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="header-title mb-3" style="font-size: 15px;">WHT Records by States - MTD</h4>

                                    <div class="table-responsive table-wrapper-scroll-y my-custom-scrollbar">
                                        <table class="table mb-0" >
                                            <thead class="bg-dark text-white" style="font-size: 12px;">
                                                <tr>
                                                    <th>#</th>
                                                    <th>STATES</th>
                                                    <th>INTEREST</th>
                                                    <th>DIVIDENDS</th>
                                                    <th>RENTS</th>
                                                    <th>CONTRACTS</th>
                                                    <th>ROYALTIES</th>
                                                    <th>TOTAL</th>
                                                </tr>
                                            </thead>
                                            <tbody style="color: #6c757d; font-size: 11px;">
                                                <!-- {{responseState}} -->
                                                <tr v-for="(records, index) in countState" :key="index">
                                                    <td>{{index + 1}}</td>
                                                    <td>{{Object.keys(records)[0]}}</td>
                                                    <td>{{Object.values(records)[0].Interest[0].whtAmount | toCurrency}}</td>
                                                    <td>{{Object.values(records)[0].Dividend[0].whtAmount | toCurrency}}</td>
                                                    <td>{{Object.values(records)[0].Rent[0].whtAmount | toCurrency}}</td>
                                                    <td>{{Object.values(records)[0].Contract[0].whtAmount | toCurrency}}</td>
                                                    <td>{{Object.values(records)[0].Royalty[0].whtAmount | toCurrency}}</td>
                                                    <td>{{Object.values(records)[0].stateTotal | toCurrency}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div><br>

                        <div class="col-xl-6 " style=" padding-top: 30px;">
                            <div class="row" style="padding-bottom: 15px;">
                                <div class="col-md-12">
                                    <div class="card widget-box-three bg-info text-white">
                                        <div class="card-body">
                                            <div class="media">
                                                <div class="avatar-lg text-center pt-3 bg-light rounded-circle">
                                                    <v-icon name="database" class="w-50" style="color:#18a2b8"></v-icon>
                                                </div>
                                                <div class="media-body text-right ml-2">
                                                    <p class="text-uppercase">Agent Count</p>
                                                    <h2 class="mb-0"><span data-plugin="counterup">{{agentCount}}</span></h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <h4 class="header-title mb-3" style="font-size: 15px;">WHT Total Gross Collections - MTD</h4>

                                            <div class="table-responsive">
                                                <table class="table mb-0">
                                                    <thead style="font-size: 15px;">
                                                        <tr>
                                                            <th><span class="badge badge-warning text-white">#</span></th>
                                                            <th><span class="badge badge-info">WHT CATEGORIES</span></th>
                                                            <th><span class="badge badge-success">GROSS</span></th>
                                                            <th><span class="badge badge-warning text-white">COUNT</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style="font-size: 13px; color: #6c757d;">
                                                        <tr v-for="(records, index) in countItem" :key="index">
                                                            <td></td>
                                                            <th class="row">{{index}}</th>
                                                            <td>{{records[0].whtAmount | toCurrency }}</td>
                                                            <td>{{records[1].count}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <!-- end row -->

                </div> <!-- end container-fluid -->
            </div>
            <!-- end row -->
        </div> <!-- end content -->
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'Dashpanel',
    data() {
        return {
            agentCount: 0, countState: null, countItem: null, 
            plotnow: false, plotYear: false,

            Dividend: {count:0,amount:0},
            Interest: {count:0,amount:0},
            Rent: {count:0,amount:0},
            Royalty: {count:0,amount:0},
            Contract: {count:0,amount:0},
            Loan :{count:0,amount:0},

            series1: [], 
            options1: {},
            series: [], labels:[], 
            options: {
                chart: {
                    id: 'vuechart-example',
                    stacked: true,
                },
                plotOptions: {
                    bar: {
                        vertical: true,
                    },
                },
                xaxis: {
                    categories: [ 'Year To Date']
                }
            },
           
        }
    },

    computed:{
        ...mapState(['token'])
    },

    mounted(){
        const baseU = `${this.$urlUpload}/count`;
        const baseAgent = `${this.$urlAuth}/getagentcount`;

        this.$http.get(baseAgent,{
            headers:{
                "x-access-token": this.token
            }
        })
        .then(response => {
            if(response.data.data.code =='S200'){
                this.agentCount = response.data.data.message
            }else{
                this.$toastr.e("Error loading Dashbaord components");
            }
        })
        .catch(e => {
            console.log(e)
            this.$toastr.e("Connection error, error loading dashboard");
        })

        this.$http.get(baseU,{
            headers:{
                "x-access-token": this.token
            }
        })
        .then(response => {
            if(response.data.data.code == 'S200'){
                // console.log(response.data.data.message)

                let {countItem, countYear, countItemsState} = response.data.data.message

                this.doAll(countItem, countYear)

                this.countItem = countItem
                this.countState = countItemsState
                
            }else{
                this.$toastr.e("Error loading Dashbaord components");
            }
        })
        .catch(e => {
            console.log(e)
            this.$toastr.e("Connection error, error loading dashboard");
        })

    },

    methods:{
        doAll(countItem, countItemYear){

            this.countPlotItem(countItem)
            this.countYear(countItemYear)

        },
        countPlotItem(itemObj){
            const barplot = [];
            const barlabel = [];

            for (const key in itemObj) {
                if (itemObj.hasOwnProperty(key)) {
                    const value = itemObj[key];

                    this[key].count = value[1].count
                    this[key].amount = value[0].whtAmount;
                    // console.log(value[0])

                    if(value[1].count > 0) {
                        this.plotnow = true;
                    }

                    barlabel.push(key);
                    barplot.push(value[0].whtAmount);
                }
            }

            this.series1 = barplot
            this.labels = barlabel
            this.options1.labels = barlabel
        },
        countYear(itemObj){
            this.series=[];

            for (const key in itemObj) {
                if (itemObj.hasOwnProperty(key)) {
                    const value = itemObj[key];

                    if(value[1].count > 0) {
                        this.plotYear = true;
                    }

                    this.series.push({name:key, data:[value[0].whtAmount]})
                }
            }
        },
    
        formatPrice(value) {
            const val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    }
}

</script>

<style scoped>
    .bg-dark {
        background-color: #323a46!important
    }

    a.bg-dark:focus,
    a.bg-dark:hover,
    button.bg-dark:focus,
    button.bg-dark:hover {
        background-color: #1d2128!important
    }

    .bg-pink {
        background-color: #f06292!important
    }

    a.bg-pink:focus,
    a.bg-pink:hover,
    button.bg-pink:focus,
    button.bg-pink:hover {
        background-color: #ec3372!important
    }

    .bg-purple {
        background-color: #8892d6!important
    }

    a.bg-purple:focus,
    a.bg-purple:hover,
    button.bg-purple:focus,
    button.bg-purple:hover {
        background-color: #626fc9!important
    }

    @media (min-width:1200px) {
        .cols-xl-2 {
            -webkit-box-flex: 0 ;
            -ms-flex: 0 0 20%;
            flex: 0 0 20%;
            max-width: 20%;
            position: relative;
            width: 100%;
            padding-right: 12px;
            padding-left: 12px
        }

    }

    @media (max-width:576px) {

        .cols-sm-12 {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
            position: relative;
            width: 100%;
            padding: 8px 12px ;
        }


    }

    .my-custom-scrollbar {
        position: relative;
        height: 445px;
        overflow: auto;
    }
    .table-wrapper-scroll-y {
        display: block;
    }
    .avatar-lg{
        height:4.5rem;
        width:4.5rem
    }

    .avatar-title{
        -webkit-box-align:center;
        -ms-flex-align:center;
        align-items:center;
        color:#fff;
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        height:100%;
        -webkit-box-pack:center;
        -ms-flex-pack:center;
        justify-content:center;
        width:100%
    }

    *, ::after, ::before {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }


    @media (min-width: 768px) {
        .col-md-6 {
            padding-bottom: 10px !important;
        }
    }


    .num {
        font-weight: bold !important;

    }
</style>